import React from 'react';
import Icon from '../../../components/AppIcon';

const VehicleIdentificationCard = ({ vehicleData }) => {
  if (!vehicleData) return null;

  const identificationFields = [
    { label: 'Marca', value: vehicleData?.make, icon: 'Car' },
    { label: 'Modelo', value: vehicleData?.model, icon: 'Tag' },
    { label: 'Año', value: vehicleData?.year, icon: 'Calendar' },
    { label: 'Tipo de Vehículo', value: vehicleData?.vehicleType, icon: 'Truck' },
    { label: 'País de Origen', value: vehicleData?.countryOfOrigin, icon: 'Globe' },
    { label: 'Planta de Fabricación', value: vehicleData?.manufacturingPlant, icon: 'Factory' }
  ];

  return (
    <div className="bg-card border border-border rounded-lg p-4 shadow-elevation">
      <div className="flex items-center space-x-3 mb-4">
        <div className="flex items-center justify-center w-8 h-8 bg-primary rounded-lg">
          <Icon name="Car" size={16} color="white" />
        </div>
        <div>
          <h3 className="text-lg font-semibold text-foreground">Identificación del Vehículo</h3>
          <p className="text-sm text-muted-foreground">VIN: {vehicleData?.vin}</p>
        </div>
      </div>

      {/* Vehicle Details - Now full width without image */}
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-3 mb-4">
        {identificationFields?.map((field) => (
          <div key={field?.label} className="flex items-center space-x-2 p-3 bg-muted rounded-lg">
            <div className="flex items-center justify-center w-7 h-7 bg-background rounded-md">
              <Icon name={field?.icon} size={14} className="text-muted-foreground" />
            </div>
            <div className="flex-1 min-w-0">
              <p className="text-xs text-muted-foreground uppercase tracking-wide">{field?.label}</p>
              <p className="text-sm font-medium text-foreground truncate">{field?.value}</p>
            </div>
          </div>
        ))}
      </div>

      {/* Additional Info - Compact layout */}
      <div className="p-3 bg-muted rounded-lg mb-4">
        <div className="flex items-center space-x-2 mb-2">
          <Icon name="Info" size={14} className="text-muted-foreground" />
          <span className="text-sm font-medium text-foreground">Información Adicional</span>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-2 text-sm">
          <div className="flex justify-between">
            <span className="text-muted-foreground">Número de Serie:</span>
            <span className="font-mono text-foreground">{vehicleData?.serialNumber}</span>
          </div>
          <div className="flex justify-between">
            <span className="text-muted-foreground">Código de Motor:</span>
            <span className="font-mono text-foreground">{vehicleData?.engineCode}</span>
          </div>
          <div className="flex justify-between">
            <span className="text-muted-foreground">Transmisión:</span>
            <span className="text-foreground">{vehicleData?.transmission}</span>
          </div>
          <div className="flex justify-between">
            <span className="text-muted-foreground">Combustible:</span>
            <span className="text-foreground">{vehicleData?.fuelType}</span>
          </div>
        </div>
      </div>

      {/* Status Indicators - Compact */}
      <div className="pt-3 border-t border-border">
        <div className="flex flex-wrap items-center gap-3">
          <div className="flex items-center space-x-2">
            <div className="w-2 h-2 bg-success rounded-full"></div>
            <span className="text-sm text-muted-foreground">VIN Válido</span>
          </div>
          <div className="flex items-center space-x-2">
            <Icon name="Shield" size={12} className="text-success" />
            <span className="text-sm text-muted-foreground">Verificado</span>
          </div>
          <div className="flex items-center space-x-2">
            <Icon name="Clock" size={12} className="text-muted-foreground" />
            <span className="text-sm text-muted-foreground">Decodificado en 1.2s</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default VehicleIdentificationCard;